"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyBody = exports.LogoUploadUrl = exports.BrandList = exports.Brand = exports.ReplaceBody = exports.UpdateBody = exports.CreateBody = exports.Color = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const entity_1 = require("../../../../../../../entity");
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.System.Brands.Schema';
/*
 * `controllers/v2/system/brand.js` + `db/repositories/brandrepository.js`
 * (protocol v1, express-validator)
 */
exports.Color = effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)).annotations({
    identifier: `${exports.NAMESPACE}.Color`,
    title: 'Hex colour',
    description: 'Brand colour as `#rgb` or `#rrggbb`',
    examples: ['#42a5f5'],
});
const fields = {
    name: effect_1.Schema.NonEmptyString.annotations({ description: 'Brand name, unique across brands' }),
    countries: effect_1.Schema.NonEmptyArray(effect_1.Schema.NonEmptyString).annotations({
        description: 'Countries where the brand operates',
    }),
    address: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString), { exact: true }).annotations({
        description: 'Brand address',
    }),
    domain: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Array(effect_1.Schema.NonEmptyString)), { exact: true }).annotations({
        description: 'URL domains of the brand',
    }),
    color: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(exports.Color), { exact: true }),
    logo: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString), { exact: true }).annotations({
        description: 'Storage path of the brand logo',
    }),
};
/** `POST /v2/system/brands` body. */
exports.CreateBody = effect_1.Schema.Struct(fields).annotations({
    identifier: `${exports.NAMESPACE}.CreateBody`,
    title: 'BrandRequestBody',
    description: 'A new brand. `name` must not be used by another brand.',
});
/** `PATCH /v2/system/brands` body: every field optional, at least one required. */
exports.UpdateBody = effect_1.Schema.Struct({
    name: effect_1.Schema.optionalWith(fields.name, { exact: true }),
    countries: effect_1.Schema.optionalWith(fields.countries, { exact: true }),
    address: fields.address,
    domain: fields.domain,
    color: fields.color,
    logo: fields.logo,
}).annotations({
    identifier: `${exports.NAMESPACE}.UpdateBody`,
    title: 'BrandPatchBody',
    description: 'Fields to change. An empty body is rejected.',
});
/** `PUT /v2/system/brands` body: the full brand; omitted optional fields are stored as `null`. */
exports.ReplaceBody = exports.CreateBody.annotations({
    identifier: `${exports.NAMESPACE}.ReplaceBody`,
    title: 'BrandPutBody',
    description: 'The whole brand. Omitted `address`, `domain`, `color` and `logo` are stored as null; a null `logo` also deletes the stored logo file.',
});
exports.Brand = effect_1.Schema.Struct({
    id: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({ description: 'Set by the backend' }),
    ...fields,
    ...entity_1.BaseTimestampedEntity.fields,
}).annotations({
    identifier: `${exports.NAMESPACE}.Brand`,
    title: 'Brand',
    description: 'A brand as stored',
});
exports.BrandList = effect_1.Schema.Struct({
    items: effect_1.Schema.Array(exports.Brand),
}).annotations({
    identifier: `${exports.NAMESPACE}.BrandList`,
});
exports.LogoUploadUrl = effect_1.Schema.Struct({
    url: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({
        description: 'Pre-signed URL the logo file may be PUT to',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.LogoUploadUrl`,
    title: 'Logo upload URL',
});
/** 422 `{ message: INVALID_REQUEST, inputValidation: "Body cannot be empty!" }` answered by PATCH on an empty body. */
exports.EmptyBody = effect_1.Schema.Struct({
    success: effect_1.Schema.Literal(false),
    error: effect_1.Schema.Struct({
        message: effect_1.Schema.Literal('INVALID_REQUEST'),
        inputValidation: effect_1.Schema.Literal('Body cannot be empty!'),
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.EmptyBody`,
    title: 'Empty Body',
    description: 'The PATCH body carries no field to change',
    [platform_1.HttpApiSchema.AnnotationStatus]: 422,
});
//# sourceMappingURL=schema.js.map